/**
 * axios setup to use mock service
 */

import { BASE_URL } from '../config';
import axios from 'axios';

const axiosServices = axios.create({
    baseURL: BASE_URL
});

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
